"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Chart, registerables } from "chart.js";
import "chartjs-adapter-moment";
import candidatesToCsv from "./autoprocessing_candidates_csv";
Chart.register(...registerables);
const METRIC_LABELS = {
  processed_per_hour: "Processed / Hour",
  exceptions: "Exceptions",
  exception_rate: "Exception Rate %",
  total_volume: "Total Volume"
};
const SCOPED_STYLES = `
.analytics-page .analytics-wrap { width: 100%; padding: 24px 32px; }
.analytics-page .card { background: #fff; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06); padding: 24px; margin-bottom: 20px; }
.analytics-page .card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; flex-wrap: wrap; gap: 12px; }
.analytics-page .card-header h2 { font-size: 16px !important; font-weight: 600 !important; color: #374151 !important; margin: 0 !important; }
.analytics-page .page-header { display: flex !important; justify-content: space-between !important; align-items: center !important; margin-bottom: 24px !important; flex-wrap: nowrap !important; gap: 12px !important; }
.analytics-page .page-header h1 { font-size: 22px !important; font-weight: 700 !important; color: #111827 !important; margin: 0 !important; }
.analytics-page .date-controls { display: flex !important; align-items: center !important; gap: 8px !important; flex-wrap: nowrap !important; flex-direction: row !important; }
.analytics-page .date-presets { display: flex; gap: 4px; }
.analytics-page .date-presets button { padding: 4px 10px !important; border: 1px solid #d1d5db !important; border-radius: 4px !important; background: #fff !important; font-size: 11px !important; color: #6b7280 !important; cursor: pointer !important; margin: 0 !important; line-height: normal !important; }
.analytics-page .date-presets button:hover { background: #f3f4f6 !important; color: #374151 !important; }
.analytics-page .date-presets button.active { background: #3b82f6 !important; color: #fff !important; border-color: #3b82f6 !important; }
.analytics-page .date-controls input[type="date"] { padding: 4px 8px !important; border: 1px solid #d1d5db !important; border-radius: 4px !important; font-size: 13px !important; font-family: inherit !important; color: #374151 !important; background: #fff !important; width: 140px !important; height: auto !important; margin: 0 !important; box-shadow: none !important; }
.analytics-page .date-controls input[type="date"]:focus { outline: none !important; border-color: #3b82f6 !important; box-shadow: 0 0 0 2px rgba(59,130,246,0.15) !important; }
.analytics-page .date-controls label { font-size: 13px !important; color: #6b7280 !important; font-weight: 500 !important; margin: 0 !important; padding: 0 !important; white-space: nowrap !important; width: auto !important; }
.analytics-page .toggle-group { display: flex !important; border: 1px solid #d1d5db !important; border-radius: 6px !important; overflow: hidden !important; }
.analytics-page .toggle-group button { padding: 6px 14px !important; border: none !important; background: #fff !important; font-size: 12px !important; font-family: inherit !important; color: #6b7280 !important; cursor: pointer !important; border-right: 1px solid #d1d5db !important; transition: background 0.15s, color 0.15s; white-space: nowrap; border-radius: 0 !important; margin: 0 !important; line-height: normal !important; }
.analytics-page .toggle-group button:last-child { border-right: none !important; }
.analytics-page .toggle-group button:hover { background: #f9fafb !important; }
.analytics-page .toggle-group button.active { background: #3b82f6 !important; color: #fff !important; }
.analytics-page .filter-badge { display: inline-flex !important; align-items: center; gap: 6px; padding: 4px 12px !important; background: #eff6ff !important; border: 1px solid #bfdbfe !important; border-radius: 20px !important; font-size: 12px !important; color: #1d4ed8 !important; }
.analytics-page .filter-badge button { background: none !important; border: none !important; color: #1d4ed8 !important; cursor: pointer !important; font-size: 14px !important; line-height: 1 !important; padding: 0 !important; margin: 0 !important; border-radius: 0 !important; }
.analytics-page .filter-badge button:hover { color: #1e40af !important; }
.analytics-page .chart-container { position: relative; width: 100%; min-height: 300px; }
.analytics-page .chart-message { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-size: 14px; color: #6b7280; z-index: 2; }
.analytics-page .chart-message.error { color: #dc2626; }
.analytics-page .chart-loading-overlay { position: absolute; inset: 0; background: rgba(255,255,255,0.6); display: flex; align-items: center; justify-content: center; z-index: 1; font-size: 13px; color: #9ca3af; transition: opacity 0.15s; }
.analytics-page .card.is-loading { pointer-events: none; }
.analytics-page .analytics-tab-bar { display: flex !important; gap: 0; border-bottom: 2px solid #e5e7eb; margin-bottom: 24px; list-style: none !important; padding: 0 !important; background: none !important; }
.analytics-page .analytics-tab-bar a,
.analytics-page .analytics-tab-bar span { padding: 10px 20px !important; font-size: 14px !important; font-weight: 500 !important; color: #6b7280 !important; text-decoration: none !important; border-bottom: 2px solid transparent; margin-bottom: -2px; transition: color 0.15s, border-color 0.15s; background: none !important; line-height: normal !important; }
.analytics-page .analytics-tab-bar a:hover { color: #374151 !important; }
.analytics-page .analytics-tab-bar a.active { color: #3b82f6 !important; border-bottom-color: #3b82f6; }
.analytics-page .analytics-tab-bar span.disabled { opacity: 0.4; cursor: default; }
.analytics-page table.data-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.analytics-page table.data-table th { text-align: left; padding: 8px 12px; border-bottom: 2px solid #e5e7eb; color: #6b7280; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: 0.05em; }
.analytics-page table.data-table td { padding: 8px 12px; border-bottom: 1px solid #f3f4f6; color: #374151; }
.analytics-page table.data-table tr:hover { background: #f9fafb; }
.analytics-page table.data-table tr.clickable { cursor: pointer; }
.analytics-page table.data-table tr.clickable:hover { background: #eff6ff; }
`;
function toDateStr(d) {
  return d.toISOString().slice(0, 10);
}
function computePresetDates(preset) {
  var now = /* @__PURE__ */ new Date();
  var start;
  var end;
  switch (preset) {
    case "today":
      start = end = now;
      break;
    case "this_week":
      start = new Date(now);
      start.setDate(now.getDate() - now.getDay());
      end = now;
      break;
    case "last_week":
      start = new Date(now);
      start.setDate(now.getDate() - now.getDay() - 7);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
      break;
    case "this_month":
      start = new Date(now.getFullYear(), now.getMonth(), 1);
      end = now;
      break;
    case "last_month":
      start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      end = new Date(now.getFullYear(), now.getMonth(), 0);
      break;
  }
  return { start: toDateStr(start), end: toDateStr(end) };
}
function getCsrfToken() {
  var _a;
  return ((_a = document.querySelector('meta[name="csrf-token"]')) == null ? void 0 : _a.getAttribute("content")) || "";
}
function fetchWithAuth(url) {
  return fetch(url, {
    credentials: "same-origin",
    headers: {
      "X-CSRF-Token": getCsrfToken(),
      Accept: "application/json"
    }
  }).then(function(r) {
    if (r.status == 404)
      throw new Error(
        "Analytics is not enabled for this account. Please contact your administrator to enable this feature."
      );
    if (!r.ok) throw new Error(`Failed to load data (${r.status})`);
    return r.json();
  });
}
class AnalyticsPage extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "styleEl", null);
    __publicField(this, "chartInstance", null);
    __publicField(this, "hourlyChartInstance", null);
    __publicField(this, "exceptionChartInstance", null);
    __publicField(this, "canvasEl");
    __publicField(this, "hourlyCanvasEl");
    __publicField(this, "exceptionCanvasEl");
    this.canvasEl = null;
    this.hourlyCanvasEl = null;
    this.exceptionCanvasEl = null;
    var today = toDateStr(/* @__PURE__ */ new Date());
    this.state = {
      loading: true,
      error: null,
      processors: [],
      currentMetric: "processed_per_hour",
      activePreset: "today",
      startDate: today,
      endDate: today,
      filteredUserId: null,
      filteredEmail: null,
      hourlyData: [],
      hourlyLoading: false,
      hourlyError: null,
      activeTab: "daily_ops",
      exceptionClients: [],
      exceptionClientsLoading: false,
      exceptionClientsError: null,
      filteredCarrierId: null,
      exceptionTypes: [],
      exceptionTypesLoading: false,
      exceptionTypesError: null,
      filteredExceptionType: null,
      filteredRuleType: null,
      filteredFailureType: null,
      filteredDataType: null,
      exceptionInvoices: [],
      exceptionInvoicesLoading: false,
      exceptionInvoicesError: null,
      candidates: [],
      candidatesLoading: false,
      candidatesError: null,
      selectedCandidateId: null,
      selectedCandidateName: null,
      corrections: [],
      correctionsLoading: false,
      correctionsError: null,
      ruleFailures: [],
      ruleFailuresLoading: false,
      ruleFailuresError: null,
      candidateSortKey: "pct_potential_autoprocessing",
      candidateSortAsc: false,
      candidateNameFilter: "",
      candidatesTotalQualifying: 0,
      candidatesIncludeEnabled: false,
      candidateClientNames: [],
      candidateClientFilter: null
    };
  }
  componentDidMount() {
    this.injectStyles();
    this.fetchData();
  }
  componentWillUnmount() {
    if (this.styleEl) {
      document.head.removeChild(this.styleEl);
      this.styleEl = null;
    }
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
    if (this.hourlyChartInstance) {
      this.hourlyChartInstance.destroy();
      this.hourlyChartInstance = null;
    }
    if (this.exceptionChartInstance) {
      this.exceptionChartInstance.destroy();
      this.exceptionChartInstance = null;
    }
  }
  componentDidUpdate(_prevProps, prevState) {
    var metricChanged = prevState.currentMetric !== this.state.currentMetric;
    var filterChanged = prevState.filteredUserId !== this.state.filteredUserId;
    var processorsChanged = prevState.processors !== this.state.processors;
    var hourlyDataChanged = prevState.hourlyData !== this.state.hourlyData;
    var exceptionClientsChanged = prevState.exceptionClients !== this.state.exceptionClients;
    var exceptionFilterChanged = prevState.filteredCarrierId !== this.state.filteredCarrierId;
    if (metricChanged || processorsChanged) {
      this.renderChart();
    } else if (filterChanged) {
      this.updateChartColors();
    }
    if (hourlyDataChanged) {
      this.renderHourlyChart();
    }
    if (exceptionClientsChanged) {
      this.renderExceptionChart();
    } else if (exceptionFilterChanged) {
      this.updateExceptionChartColors();
      this.fetchExceptionTypes();
      this.fetchExceptionInvoices();
    }
    var exceptionTypeFilterChanged = prevState.filteredExceptionType !== this.state.filteredExceptionType;
    if (exceptionTypeFilterChanged) {
      this.fetchExceptionInvoices();
    }
  }
  injectStyles() {
    this.styleEl = document.createElement("style");
    this.styleEl.textContent = SCOPED_STYLES;
    document.head.appendChild(this.styleEl);
  }
  fetchData() {
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    var url = "/api/analytics/processor_performance?start_date=" + startDate + "&end_date=" + endDate;
    this.setState({ loading: true, error: null });
    fetchWithAuth(url).then((data) => {
      this.setState({
        processors: data.processors || [],
        loading: false
      });
      this.fetchHourlyData();
    }).catch((err) => {
      this.setState({
        loading: false,
        error: err.message || "Failed to load processor performance data."
      });
    });
  }
  fetchHourlyData() {
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    var url = "/api/analytics/hourly_activity?start_date=" + startDate + "&end_date=" + endDate;
    if (this.state.filteredUserId) {
      url += "&user_id=" + this.state.filteredUserId;
    }
    this.setState({ hourlyLoading: true, hourlyError: null });
    fetchWithAuth(url).then((data) => {
      this.setState({
        hourlyData: data.hours || [],
        hourlyLoading: false
      });
    }).catch((err) => {
      this.setState({
        hourlyLoading: false,
        hourlyError: "Failed to load hourly activity data."
      });
    });
  }
  renderChart() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
    var canvas = this.canvasEl;
    if (!canvas) return;
    var processors = this.state.processors || [];
    if (processors.length === 0) return;
    var currentMetric = this.state.currentMetric || "processed_per_hour";
    var filteredUserId = this.state.filteredUserId;
    var sorted = processors.slice().sort(function(a, b) {
      return (b[currentMetric] || 0) - (a[currentMetric] || 0);
    });
    var labels = sorted.map(function(p) {
      return p.email;
    });
    var values = sorted.map(function(p) {
      return p[currentMetric] || 0;
    });
    var userIds = sorted.map(function(p) {
      return p.user_id;
    });
    var bgColors = userIds.map(function(uid) {
      if (!filteredUserId) return "#3b82f6";
      return uid === filteredUserId ? "#3b82f6" : "#bfdbfe";
    });
    var ctx = canvas.getContext("2d");
    if (!ctx) return;
    var self = this;
    this.chartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: METRIC_LABELS[currentMetric],
            data: values,
            backgroundColor: bgColors,
            borderRadius: 4,
            barThickness: 22
          }
        ]
      },
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function(tooltipCtx) {
                var val = tooltipCtx.parsed.x;
                if (currentMetric === "exception_rate")
                  return val.toFixed(1) + "%";
                if (currentMetric === "processed_per_hour")
                  return val.toFixed(1);
                return val;
              }
            }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            title: {
              display: true,
              text: METRIC_LABELS[currentMetric],
              font: { size: 12 }
            },
            grid: { color: "#f3f4f6" }
          },
          y: {
            grid: { display: false },
            ticks: { font: { size: 12 } }
          }
        },
        onHover: function(evt, elements) {
          evt.native.target.style.cursor = elements.length > 0 ? "pointer" : "default";
        },
        onClick: function(_evt, elements) {
          if (elements.length > 0) {
            var idx = elements[0].index;
            var clickedUserId = userIds[idx];
            if (self.state.filteredUserId === clickedUserId) {
              self.clearFilter();
            } else {
              self.setState(
                { filteredUserId: clickedUserId, filteredEmail: labels[idx] },
                function() {
                  self.fetchHourlyData();
                }
              );
            }
          }
        }
      }
    });
    var wrapper = canvas.parentElement;
    if (wrapper) {
      wrapper.style.minHeight = Math.max(300, sorted.length * 32 + 60) + "px";
    }
  }
  updateChartColors() {
    if (!this.chartInstance) return;
    var currentMetric = this.state.currentMetric || "processed_per_hour";
    var filteredUserId = this.state.filteredUserId;
    var ds = this.chartInstance.data.datasets[0];
    var sortedUserIds = (this.state.processors || []).slice().sort(function(a, b) {
      return (b[currentMetric] || 0) - (a[currentMetric] || 0);
    }).map(function(p) {
      return p.user_id;
    });
    ds.backgroundColor = sortedUserIds.map(function(uid) {
      if (!filteredUserId) return "#3b82f6";
      return uid === filteredUserId ? "#3b82f6" : "#bfdbfe";
    });
    this.chartInstance.update("none");
  }
  renderHourlyChart() {
    if (this.hourlyChartInstance) {
      this.hourlyChartInstance.destroy();
      this.hourlyChartInstance = null;
    }
    var canvas = this.hourlyCanvasEl;
    if (!canvas) return;
    var hourlyData = this.state.hourlyData;
    if (!hourlyData || hourlyData.length === 0) return;
    var hours = hourlyData.map(function(d) {
      return d.hour;
    });
    var ctx = canvas.getContext("2d");
    if (!ctx) return;
    this.hourlyChartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels: hours,
        datasets: [
          {
            label: "Processed",
            data: hourlyData.map(function(d) {
              return d.processed;
            }),
            backgroundColor: "#22c55e"
          },
          {
            label: "Exception",
            data: hourlyData.map(function(d) {
              return d.exception;
            }),
            backgroundColor: "#ef4444"
          },
          {
            label: "Ignored",
            data: hourlyData.map(function(d) {
              return d.ignored;
            }),
            backgroundColor: "#94a3b8"
          },
          {
            label: "Forwarded",
            data: hourlyData.map(function(d) {
              return d.forwarded;
            }),
            backgroundColor: "#3b82f6"
          },
          {
            label: "Other",
            data: hourlyData.map(function(d) {
              return d.other;
            }),
            backgroundColor: "#eab308"
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
            labels: {
              boxWidth: 12,
              padding: 16,
              font: { size: 12 }
            }
          }
        },
        scales: {
          x: {
            type: "time",
            time: {
              unit: "hour",
              displayFormats: { hour: "ha" },
              tooltipFormat: "MMM D, ha"
            },
            stacked: true,
            grid: { color: "#f3f4f6" }
          },
          y: {
            stacked: true,
            beginAtZero: true,
            title: {
              display: true,
              text: "Documents",
              font: { size: 12 }
            },
            grid: { color: "#f3f4f6" }
          }
        }
      }
    });
  }
  handlePresetClick(preset) {
    var dates = computePresetDates(preset);
    this.setState(
      {
        activePreset: preset,
        startDate: dates.start,
        endDate: dates.end,
        filteredUserId: null,
        filteredEmail: null,
        filteredCarrierId: null,
        filteredExceptionType: null,
        filteredRuleType: null,
        filteredFailureType: null,
        filteredDataType: null,
        exceptionInvoices: [],
        exceptionInvoicesError: null,
        selectedCandidateId: null,
        selectedCandidateName: null,
        corrections: [],
        correctionsLoading: false,
        correctionsError: null,
        ruleFailures: [],
        ruleFailuresLoading: false,
        ruleFailuresError: null
      },
      () => {
        if (this.state.activeTab === "exceptions") {
          this.fetchExceptionClients();
          this.fetchExceptionTypes();
        } else if (this.state.activeTab === "candidates") {
          this.fetchCandidates();
        } else {
          this.fetchData();
        }
      }
    );
  }
  handleDateChange(field, value) {
    this.setState(
      {
        [field]: value,
        activePreset: null,
        filteredUserId: null,
        filteredEmail: null,
        filteredCarrierId: null,
        filteredExceptionType: null,
        filteredRuleType: null,
        filteredFailureType: null,
        filteredDataType: null,
        exceptionInvoices: [],
        exceptionInvoicesError: null,
        selectedCandidateId: null,
        selectedCandidateName: null,
        corrections: [],
        correctionsLoading: false,
        correctionsError: null,
        ruleFailures: [],
        ruleFailuresLoading: false,
        ruleFailuresError: null
      },
      () => {
        if (this.state.activeTab === "exceptions") {
          this.fetchExceptionClients();
          this.fetchExceptionTypes();
        } else if (this.state.activeTab === "candidates") {
          this.fetchCandidates();
        } else {
          this.fetchData();
        }
      }
    );
  }
  handleMetricClick(metric) {
    this.setState({ currentMetric: metric });
  }
  clearFilter() {
    this.setState({ filteredUserId: null, filteredEmail: null }, () => {
      this.fetchHourlyData();
    });
  }
  handleTabClick(tab) {
    if (tab === this.state.activeTab) return;
    if (tab === "candidates") {
      this.setState(
        (prevState) => {
          var candidateDates = prevState.activePreset === "today" ? computePresetDates("last_month") : null;
          return {
            activeTab: tab,
            selectedCandidateId: null,
            selectedCandidateName: null,
            corrections: [],
            correctionsLoading: false,
            correctionsError: null,
            ruleFailures: [],
            ruleFailuresLoading: false,
            ruleFailuresError: null,
            activePreset: candidateDates ? "last_month" : prevState.activePreset,
            startDate: candidateDates ? candidateDates.start : prevState.startDate,
            endDate: candidateDates ? candidateDates.end : prevState.endDate
          };
        },
        () => {
          this.fetchCandidates();
        }
      );
      return;
    }
    if (tab === "exceptions") {
      var needsDateChange = this.state.activePreset === "today";
      if (needsDateChange) {
        var dates = computePresetDates("last_month");
        this.setState(
          {
            activeTab: tab,
            activePreset: "last_month",
            startDate: dates.start,
            endDate: dates.end,
            filteredCarrierId: null,
            filteredExceptionType: null,
            filteredRuleType: null,
            filteredFailureType: null,
            filteredDataType: null,
            exceptionInvoices: [],
            exceptionInvoicesError: null
          },
          () => {
            this.fetchExceptionClients();
            this.fetchExceptionTypes();
          }
        );
      } else {
        this.setState(
          {
            activeTab: tab,
            filteredCarrierId: null,
            filteredExceptionType: null,
            filteredRuleType: null,
            filteredFailureType: null,
            filteredDataType: null,
            exceptionInvoices: [],
            exceptionInvoicesError: null
          },
          () => {
            this.fetchExceptionClients();
            this.fetchExceptionTypes();
          }
        );
      }
    } else {
      this.setState({ activeTab: tab });
    }
  }
  fetchExceptionClients() {
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    var url = "/api/analytics/top_exception_clients?start_date=" + startDate + "&end_date=" + endDate;
    this.setState({
      exceptionClientsLoading: true,
      exceptionClientsError: null
    });
    fetchWithAuth(url).then((data) => {
      this.setState({
        exceptionClients: data.clients || [],
        exceptionClientsLoading: false
      });
    }).catch((err) => {
      this.setState({
        exceptionClientsLoading: false,
        exceptionClientsError: "Failed to load exception client data."
      });
    });
  }
  renderExceptionChart() {
    if (this.exceptionChartInstance) {
      this.exceptionChartInstance.destroy();
      this.exceptionChartInstance = null;
    }
    var canvas = this.exceptionCanvasEl;
    if (!canvas) return;
    var clients = this.state.exceptionClients || [];
    if (clients.length === 0) return;
    var top20 = clients.slice(0, 20);
    var filteredCarrierId = this.state.filteredCarrierId;
    var labels = top20.map(function(c) {
      return c.name;
    });
    var values = top20.map(function(c) {
      return c.exception_count;
    });
    var carrierIds = top20.map(function(c) {
      return c.carrier_id;
    });
    var bgColors = carrierIds.map(function(cid) {
      if (!filteredCarrierId) return "#ef4444";
      return cid === filteredCarrierId ? "#ef4444" : "#fecaca";
    });
    var ctx = canvas.getContext("2d");
    if (!ctx) return;
    var self = this;
    this.exceptionChartInstance = new Chart(ctx, {
      type: "bar",
      data: {
        labels,
        datasets: [
          {
            label: "Exceptions",
            data: values,
            backgroundColor: bgColors,
            borderRadius: 4,
            barThickness: 22
          }
        ]
      },
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function(tooltipCtx) {
                return tooltipCtx.parsed.x + " exceptions";
              }
            }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            title: {
              display: true,
              text: "Exception Count",
              font: { size: 12 }
            },
            grid: { color: "#f3f4f6" }
          },
          y: {
            grid: { display: false },
            ticks: { font: { size: 12 } }
          }
        },
        onHover: function(evt, elements) {
          evt.native.target.style.cursor = elements.length > 0 ? "pointer" : "default";
        },
        onClick: function(_evt, elements) {
          if (elements.length > 0) {
            var idx = elements[0].index;
            var clickedCarrierId = carrierIds[idx];
            if (self.state.filteredCarrierId === clickedCarrierId) {
              self.clearCarrierFilter();
            } else {
              self.setState({
                filteredCarrierId: clickedCarrierId,
                filteredExceptionType: null,
                filteredRuleType: null,
                filteredFailureType: null,
                filteredDataType: null
              });
            }
          }
        }
      }
    });
    var wrapper = canvas.parentElement;
    if (wrapper) {
      wrapper.style.minHeight = Math.max(300, top20.length * 32 + 60) + "px";
    }
  }
  updateExceptionChartColors() {
    if (!this.exceptionChartInstance) return;
    var clients = (this.state.exceptionClients || []).slice(0, 20);
    var filteredCarrierId = this.state.filteredCarrierId;
    var ds = this.exceptionChartInstance.data.datasets[0];
    ds.backgroundColor = clients.map(function(c) {
      if (!filteredCarrierId) return "#ef4444";
      return c.carrier_id === filteredCarrierId ? "#ef4444" : "#fecaca";
    });
    this.exceptionChartInstance.update("none");
  }
  fetchExceptionTypes() {
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    var url = "/api/analytics/exception_types?start_date=" + startDate + "&end_date=" + endDate;
    if (this.state.filteredCarrierId) {
      url += "&carrier_id=" + this.state.filteredCarrierId;
    }
    this.setState({ exceptionTypesLoading: true, exceptionTypesError: null });
    fetchWithAuth(url).then((data) => {
      this.setState({
        exceptionTypes: data.exception_types || [],
        exceptionTypesLoading: false
      });
    }).catch((_err) => {
      this.setState({
        exceptionTypesLoading: false,
        exceptionTypesError: "Failed to load exception types data."
      });
    });
  }
  handleExceptionTypeClick(t) {
    if (this.state.filteredExceptionType === t.type) {
      this.setState({
        filteredExceptionType: null,
        filteredRuleType: null,
        filteredFailureType: null,
        filteredDataType: null
      });
    } else {
      this.setState({
        filteredExceptionType: t.type,
        filteredRuleType: t.rule_type,
        filteredFailureType: t.failure_type,
        filteredDataType: t.data_type
      });
    }
  }
  fetchExceptionInvoices() {
    var hasCarrierFilter = !!this.state.filteredCarrierId;
    var hasTypeFilter = !!this.state.filteredExceptionType;
    if (!hasCarrierFilter && !hasTypeFilter) {
      this.setState({
        exceptionInvoices: [],
        exceptionInvoicesLoading: false,
        exceptionInvoicesError: null
      });
      return;
    }
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    var url = "/api/analytics/exception_invoices?start_date=" + startDate + "&end_date=" + endDate;
    if (this.state.filteredCarrierId) {
      url += "&carrier_id=" + this.state.filteredCarrierId;
    }
    if (this.state.filteredRuleType) {
      url += "&rule_type=" + encodeURIComponent(this.state.filteredRuleType);
    }
    if (this.state.filteredFailureType) {
      url += "&failure_type=" + encodeURIComponent(this.state.filteredFailureType);
    }
    if (this.state.filteredDataType) {
      url += "&data_type=" + encodeURIComponent(this.state.filteredDataType);
    }
    this.setState({
      exceptionInvoicesLoading: true,
      exceptionInvoicesError: null
    });
    fetchWithAuth(url).then((data) => {
      this.setState({
        exceptionInvoices: data.invoices || [],
        exceptionInvoicesLoading: false
      });
    }).catch((_err) => {
      this.setState({
        exceptionInvoicesLoading: false,
        exceptionInvoicesError: "Failed to load exception invoices."
      });
    });
  }
  fetchCandidates() {
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    var includeEnabled = this.state.candidatesIncludeEnabled;
    var clientFilter = this.state.candidateClientFilter;
    var url = "/api/analytics/autoprocessing_candidates?start_date=" + startDate + "&end_date=" + endDate + (includeEnabled ? "&include_enabled=true" : "") + (clientFilter ? "&client_name=" + encodeURIComponent(clientFilter) : "");
    var isStale = () => this.isStaleRange(startDate, endDate) || this.state.candidatesIncludeEnabled !== includeEnabled || this.state.candidateClientFilter !== clientFilter;
    this.setState({ candidatesLoading: true, candidatesError: null });
    fetchWithAuth(url).then(
      (data) => {
        if (isStale()) return;
        this.setState({
          candidates: data.candidates || [],
          candidateClientNames: data.client_names || [],
          candidatesTotalQualifying: data.total_qualifying || 0,
          candidatesLoading: false
        });
      }
    ).catch((_err) => {
      if (isStale()) return;
      this.setState({
        candidatesLoading: false,
        candidatesError: "Failed to load autoprocessing candidates."
      });
    });
  }
  isStaleRange(startDate, endDate) {
    return this.state.startDate !== startDate || this.state.endDate !== endDate;
  }
  fetchCorrections() {
    var candidateId = this.state.selectedCandidateId;
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    if (!candidateId) {
      this.setState({
        corrections: [],
        correctionsLoading: false,
        correctionsError: null
      });
      return;
    }
    var url = "/api/analytics/candidate_corrections?start_date=" + startDate + "&end_date=" + endDate + "&carrier_id=" + candidateId;
    this.setState({ correctionsLoading: true, correctionsError: null });
    fetchWithAuth(url).then((data) => {
      if (this.state.selectedCandidateId !== candidateId) return;
      if (this.isStaleRange(startDate, endDate)) return;
      this.setState({
        corrections: data.corrections || [],
        correctionsLoading: false
      });
    }).catch((_err) => {
      if (this.state.selectedCandidateId !== candidateId) return;
      if (this.isStaleRange(startDate, endDate)) return;
      this.setState({
        correctionsLoading: false,
        correctionsError: "Failed to load corrections."
      });
    });
  }
  fetchRuleFailures() {
    var candidateId = this.state.selectedCandidateId;
    var startDate = this.state.startDate;
    var endDate = this.state.endDate;
    if (!candidateId) {
      this.setState({
        ruleFailures: [],
        ruleFailuresLoading: false,
        ruleFailuresError: null
      });
      return;
    }
    var url = "/api/analytics/candidate_rule_failures?start_date=" + startDate + "&end_date=" + endDate + "&carrier_id=" + candidateId;
    this.setState({ ruleFailuresLoading: true, ruleFailuresError: null });
    fetchWithAuth(url).then((data) => {
      if (this.state.selectedCandidateId !== candidateId) return;
      if (this.isStaleRange(startDate, endDate)) return;
      this.setState({
        ruleFailures: data.rule_failures || [],
        ruleFailuresLoading: false
      });
    }).catch((_err) => {
      if (this.state.selectedCandidateId !== candidateId) return;
      if (this.isStaleRange(startDate, endDate)) return;
      this.setState({
        ruleFailuresLoading: false,
        ruleFailuresError: "Failed to load rule failures."
      });
    });
  }
  handleCandidateClick(candidate) {
    if (this.state.selectedCandidateId === candidate.carrier_id) {
      this.clearCandidateSelection();
      return;
    }
    this.setState(
      {
        selectedCandidateId: candidate.carrier_id,
        selectedCandidateName: candidate.name
      },
      () => {
        this.fetchCorrections();
        this.fetchRuleFailures();
      }
    );
  }
  // First click on a new column sorts descending, since for every column here the
  // interesting end is the high one. Clicking the active column flips direction.
  handleCandidateSort(key) {
    this.setState(
      (prevState) => prevState.candidateSortKey === key ? { candidateSortAsc: !prevState.candidateSortAsc } : { candidateSortKey: key, candidateSortAsc: false }
    );
  }
  // The server filters, so a client past the row limit can still be found. Only
  // a name chosen from the suggestions is sent; partial text filters nothing.
  handleCandidateNameInput(value) {
    var names = this.state.candidateClientNames || [];
    var chosen = names.indexOf(value) !== -1 ? value : null;
    this.setState({ candidateNameFilter: value });
    if (chosen !== this.state.candidateClientFilter) {
      this.setState(
        { candidateClientFilter: chosen },
        () => this.fetchCandidates()
      );
    }
  }
  sortedCandidates() {
    var candidates = (this.state.candidates || []).slice();
    var key = this.state.candidateSortKey || "pct_potential_autoprocessing";
    var ascending = !!this.state.candidateSortAsc;
    candidates.sort(function(a, b) {
      var aVal = a[key];
      var bVal = b[key];
      if (key === "manual_review_percentage") {
        aVal = aVal === null ? 100 : aVal;
        bVal = bVal === null ? 100 : bVal;
      }
      var result;
      if (typeof aVal === "string" && typeof bVal === "string") {
        result = aVal.localeCompare(bVal);
      } else {
        result = aVal - bVal;
      }
      if (result === 0) result = b.reviewed - a.reviewed;
      return ascending ? result : -result;
    });
    return candidates;
  }
  // Every loaded row in the server's ranking, deliberately ignoring the table's
  // sort: the file is then the same one regardless of how the table happens to be
  // sorted when it is downloaded.
  downloadCandidatesCsv() {
    var blob = new Blob([candidatesToCsv(this.state.candidates || [])], {
      type: "text/csv"
    });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = "autoprocessing_candidates_" + this.state.startDate + "_" + this.state.endDate + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
  clearCandidateSelection() {
    this.setState({
      selectedCandidateId: null,
      selectedCandidateName: null,
      corrections: [],
      correctionsLoading: false,
      correctionsError: null,
      ruleFailures: [],
      ruleFailuresLoading: false,
      ruleFailuresError: null
    });
  }
  clearExceptionTypeFilter() {
    this.setState({
      filteredExceptionType: null,
      filteredRuleType: null,
      filteredFailureType: null,
      filteredDataType: null
    });
  }
  clearCarrierFilter() {
    this.setState(
      {
        filteredCarrierId: null,
        filteredExceptionType: null,
        filteredRuleType: null,
        filteredFailureType: null,
        filteredDataType: null,
        exceptionInvoices: [],
        exceptionInvoicesError: null
      },
      () => {
        this.updateExceptionChartColors();
        this.fetchExceptionTypes();
      }
    );
  }
  render() {
    var state = this.state;
    var activeTab = state.activeTab || "daily_ops";
    var hasData = (state.processors || []).length > 0;
    var showEmpty = !state.loading && !state.error && !hasData;
    var hasExceptionData = (state.exceptionClients || []).length > 0;
    var showExceptionEmpty = !state.exceptionClientsLoading && !state.exceptionClientsError && !hasExceptionData;
    var exceptionTypes = state.exceptionTypes || [];
    var hasExceptionTypes = exceptionTypes.length > 0;
    var showExceptionTypesEmpty = !state.exceptionTypesLoading && !state.exceptionTypesError && !hasExceptionTypes;
    var filteredCarrierName = "";
    if (state.filteredCarrierId && state.exceptionClients) {
      var matchedClient = state.exceptionClients.filter(function(c) {
        return c.carrier_id === state.filteredCarrierId;
      })[0];
      if (matchedClient) {
        filteredCarrierName = matchedClient.name;
      }
    }
    var candidatesTruncated = (state.candidatesTotalQualifying || 0) > (state.candidates || []).length;
    return /* @__PURE__ */ jsx("div", { className: "analytics-page", children: /* @__PURE__ */ jsxs("div", { className: "analytics-wrap", children: [
      /* @__PURE__ */ jsxs("div", { className: "analytics-tab-bar", children: [
        /* @__PURE__ */ jsx(
          "a",
          {
            href: "#",
            className: activeTab === "daily_ops" ? "active" : "",
            onClick: (e) => {
              e.preventDefault();
              this.handleTabClick("daily_ops");
            },
            children: "Daily Operations"
          }
        ),
        /* @__PURE__ */ jsx(
          "a",
          {
            href: "#",
            className: activeTab === "exceptions" ? "active" : "",
            onClick: (e) => {
              e.preventDefault();
              this.handleTabClick("exceptions");
            },
            children: "Exceptions"
          }
        ),
        /* @__PURE__ */ jsx(
          "a",
          {
            href: "#",
            className: activeTab === "candidates" ? "active" : "",
            onClick: (e) => {
              e.preventDefault();
              this.handleTabClick("candidates");
            },
            children: "Autoprocessing Candidates"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "page-header", children: [
        /* @__PURE__ */ jsxs("h1", { children: [
          activeTab === "daily_ops" && "Daily Operations Dashboard",
          activeTab === "exceptions" && "Exceptions Dashboard",
          activeTab === "candidates" && "Autoprocessing Candidates"
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "date-controls", children: [
          /* @__PURE__ */ jsx("div", { className: "date-presets", children: [
            ["today", "Today"],
            ["this_week", "This Week"],
            ["last_week", "Last Week"],
            ["this_month", "This Month"],
            ["last_month", "Last Month"]
          ].map(([preset, label]) => /* @__PURE__ */ jsx(
            "button",
            {
              className: state.activePreset === preset ? "active" : "",
              onClick: () => this.handlePresetClick(preset),
              children: label
            },
            preset
          )) }),
          /* @__PURE__ */ jsx("label", { children: "From" }),
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "date",
              value: state.startDate,
              onChange: (e) => this.handleDateChange("startDate", e.target.value)
            }
          ),
          /* @__PURE__ */ jsx("label", { children: "To" }),
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "date",
              value: state.endDate,
              onChange: (e) => this.handleDateChange("endDate", e.target.value)
            }
          )
        ] })
      ] }),
      activeTab === "daily_ops" && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("div", { className: state.loading ? "card is-loading" : "card", children: [
          /* @__PURE__ */ jsxs("div", { className: "card-header", children: [
            /* @__PURE__ */ jsx("h2", { children: "Processor Performance" }),
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                },
                children: [
                  state.filteredEmail && /* @__PURE__ */ jsxs("span", { className: "filter-badge", children: [
                    /* @__PURE__ */ jsxs("span", { children: [
                      "Filtered by: ",
                      state.filteredEmail
                    ] }),
                    /* @__PURE__ */ jsx(
                      "button",
                      {
                        onClick: () => this.clearFilter(),
                        title: "Clear filter",
                        children: "\xD7"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsx("div", { className: "toggle-group", children: [
                    ["processed_per_hour", "Processed/Hour"],
                    ["exceptions", "Exceptions"],
                    ["exception_rate", "Exception Rate %"],
                    ["total_volume", "Total Volume"]
                  ].map(([metric, label]) => /* @__PURE__ */ jsx(
                    "button",
                    {
                      className: state.currentMetric === metric ? "active" : "",
                      onClick: () => this.handleMetricClick(metric),
                      children: label
                    },
                    metric
                  )) })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "chart-container", children: [
            /* @__PURE__ */ jsx(
              "canvas",
              {
                ref: (el) => {
                  this.canvasEl = el;
                }
              }
            ),
            state.loading && /* @__PURE__ */ jsx("div", { className: "chart-loading-overlay", children: "Updating..." }),
            state.error && /* @__PURE__ */ jsx("div", { className: "chart-message error", children: state.error }),
            showEmpty && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "No data for selected date range." })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "card", children: [
          /* @__PURE__ */ jsxs("div", { className: "card-header", children: [
            /* @__PURE__ */ jsx("h2", { children: "Hourly Processing Activity" }),
            state.filteredUserId && /* @__PURE__ */ jsxs("span", { className: "filter-badge", children: [
              /* @__PURE__ */ jsxs("span", { children: [
                "Filtered by: ",
                state.filteredEmail
              ] }),
              /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => this.clearFilter(),
                  title: "Clear filter",
                  children: "\xD7"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              className: "chart-container",
              style: { minHeight: "300px", position: "relative" },
              children: [
                /* @__PURE__ */ jsx(
                  "canvas",
                  {
                    ref: (el) => {
                      this.hourlyCanvasEl = el;
                    }
                  }
                ),
                state.hourlyLoading && !this.hourlyChartInstance && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Loading..." }),
                state.hourlyLoading && this.hourlyChartInstance && /* @__PURE__ */ jsx("div", { className: "chart-loading-overlay", children: "Updating..." }),
                state.hourlyError && /* @__PURE__ */ jsx("div", { className: "chart-message error", children: state.hourlyError }),
                !state.hourlyLoading && !state.hourlyError && (!state.hourlyData || state.hourlyData.length === 0) && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "No data for selected date range." })
              ]
            }
          )
        ] })
      ] }),
      activeTab === "exceptions" && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: state.exceptionClientsLoading ? "card is-loading" : "card",
            children: [
              /* @__PURE__ */ jsx("div", { className: "card-header", children: /* @__PURE__ */ jsx("h2", { children: "Top Exception Clients" }) }),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: "chart-container",
                  style: { minHeight: "300px", position: "relative" },
                  children: [
                    /* @__PURE__ */ jsx(
                      "canvas",
                      {
                        ref: (el) => {
                          this.exceptionCanvasEl = el;
                        }
                      }
                    ),
                    state.exceptionClientsLoading && !this.exceptionChartInstance && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Loading..." }),
                    state.exceptionClientsLoading && this.exceptionChartInstance && /* @__PURE__ */ jsx("div", { className: "chart-loading-overlay", children: "Updating..." }),
                    state.exceptionClientsError && /* @__PURE__ */ jsx("div", { className: "chart-message error", children: state.exceptionClientsError }),
                    showExceptionEmpty && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "No data for selected date range." })
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "card", children: [
          /* @__PURE__ */ jsxs("div", { className: "card-header", children: [
            /* @__PURE__ */ jsx("h2", { children: "Exception Types" }),
            state.filteredCarrierId && /* @__PURE__ */ jsxs("span", { className: "filter-badge", children: [
              /* @__PURE__ */ jsxs("span", { children: [
                "Client: ",
                filteredCarrierName
              ] }),
              /* @__PURE__ */ jsx("button", { onClick: () => this.clearCarrierFilter(), children: "\xD7" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs("div", { style: { minHeight: "200px", position: "relative" }, children: [
            state.exceptionTypesLoading && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Loading..." }),
            state.exceptionTypesError && /* @__PURE__ */ jsx("div", { className: "chart-message error", children: state.exceptionTypesError }),
            showExceptionTypesEmpty && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "No data for selected date range." }),
            hasExceptionTypes && !state.exceptionTypesLoading && /* @__PURE__ */ jsxs("table", { className: "data-table", children: [
              /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("th", { children: "Exception Type" }),
                /* @__PURE__ */ jsx("th", { style: { textAlign: "right" }, children: "Count" })
              ] }) }),
              /* @__PURE__ */ jsx("tbody", { children: exceptionTypes.map((t, i) => /* @__PURE__ */ jsxs(
                "tr",
                {
                  className: "clickable",
                  onClick: () => this.handleExceptionTypeClick(t),
                  style: state.filteredExceptionType === t.type ? { background: "#eff6ff" } : {},
                  children: [
                    /* @__PURE__ */ jsx("td", { children: t.type }),
                    /* @__PURE__ */ jsx("td", { style: { textAlign: "right" }, children: t.count })
                  ]
                },
                i
              )) })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "card", children: [
          /* @__PURE__ */ jsxs("div", { className: "card-header", children: [
            /* @__PURE__ */ jsx("h2", { children: "Example Invoices" }),
            state.filteredExceptionType && /* @__PURE__ */ jsxs("span", { className: "filter-badge", children: [
              /* @__PURE__ */ jsxs("span", { children: [
                "Type: ",
                state.filteredExceptionType
              ] }),
              /* @__PURE__ */ jsx("button", { onClick: () => this.clearExceptionTypeFilter(), children: "\xD7" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs("div", { style: { minHeight: "200px", position: "relative" }, children: [
            !state.filteredCarrierId && !state.filteredExceptionType && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Select a client or exception type above to see invoices." }),
            state.exceptionInvoicesLoading && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Loading..." }),
            state.exceptionInvoicesError && /* @__PURE__ */ jsx("div", { className: "chart-message error", children: state.exceptionInvoicesError }),
            !state.exceptionInvoicesLoading && !state.exceptionInvoicesError && (state.filteredCarrierId || state.filteredExceptionType) && (state.exceptionInvoices || []).length === 0 && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "No invoices found for the selected filters." }),
            !state.exceptionInvoicesLoading && (state.exceptionInvoices || []).length > 0 && /* @__PURE__ */ jsxs("table", { className: "data-table", children: [
              /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("th", { children: "Date" }),
                /* @__PURE__ */ jsx("th", { children: "Carrier" }),
                /* @__PURE__ */ jsx("th", { children: "Debtor" }),
                /* @__PURE__ */ jsx("th", { children: "Invoice #" }),
                /* @__PURE__ */ jsx("th", { children: "Load ID" }),
                /* @__PURE__ */ jsx("th", { children: "Processor" })
              ] }) }),
              /* @__PURE__ */ jsx("tbody", { children: (state.exceptionInvoices || []).map((inv, i) => /* @__PURE__ */ jsx("tr", { className: "clickable", children: /* @__PURE__ */ jsx("td", { colSpan: 6, style: { padding: 0 }, children: /* @__PURE__ */ jsxs(
                "a",
                {
                  href: "/app/factor_invoices/" + inv.id,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  style: {
                    display: "flex",
                    textDecoration: "none",
                    color: "inherit"
                  },
                  children: [
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          flex: "1",
                          padding: "8px 12px"
                        },
                        children: inv.date
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          flex: "1",
                          padding: "8px 12px"
                        },
                        children: inv.carrier
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          flex: "1",
                          padding: "8px 12px"
                        },
                        children: inv.debtor
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          flex: "1",
                          padding: "8px 12px"
                        },
                        children: inv.invoice_number
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          flex: "1",
                          padding: "8px 12px"
                        },
                        children: inv.load_id
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          flex: "1",
                          padding: "8px 12px"
                        },
                        children: inv.processor
                      }
                    )
                  ]
                }
              ) }) }, i)) })
            ] })
          ] })
        ] })
      ] }),
      activeTab === "candidates" && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("div", { className: "card", children: [
          /* @__PURE__ */ jsxs("div", { className: "card-header", children: [
            /* @__PURE__ */ jsx("h2", { children: "Enablement Candidates" }),
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                },
                children: [
                  (state.candidates || []).length > 0 && /* @__PURE__ */ jsxs(
                    "span",
                    {
                      style: {
                        fontSize: "12px",
                        color: candidatesTruncated ? "#b45309" : "#6b7280"
                      },
                      title: candidatesTruncated ? "The date range has more qualifying clients than the table can load. Choose one in the client filter to find it." : "",
                      children: [
                        "Showing ",
                        (state.candidates || []).length,
                        candidatesTruncated && " of " + state.candidatesTotalQualifying + " qualifying"
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxs(
                    "label",
                    {
                      style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        fontSize: "12px",
                        color: "#374151",
                        margin: 0,
                        whiteSpace: "nowrap"
                      },
                      title: "Also list clients already at 0% manual review",
                      children: [
                        /* @__PURE__ */ jsx(
                          "input",
                          {
                            type: "checkbox",
                            checked: state.candidatesIncludeEnabled,
                            onChange: (e) => this.setState(
                              { candidatesIncludeEnabled: e.target.checked },
                              () => this.fetchCandidates()
                            ),
                            style: { margin: 0 }
                          }
                        ),
                        "Include enabled clients"
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "input",
                    {
                      list: "candidate_name_list",
                      placeholder: "Filter by client",
                      value: state.candidateNameFilter,
                      onChange: (e) => this.handleCandidateNameInput(e.target.value),
                      style: {
                        padding: "4px 8px",
                        border: "1px solid #d1d5db",
                        borderRadius: "4px",
                        fontSize: "13px",
                        fontFamily: "inherit",
                        width: "220px",
                        height: "auto",
                        margin: 0,
                        boxShadow: "none"
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx("datalist", { id: "candidate_name_list", children: (state.candidateClientNames || []).map((name) => /* @__PURE__ */ jsx("option", { value: name }, name)) }),
                  state.candidateNameFilter && /* @__PURE__ */ jsx(
                    "button",
                    {
                      onClick: () => this.handleCandidateNameInput(""),
                      style: {
                        background: "none",
                        border: "none",
                        color: "#6b7280",
                        cursor: "pointer",
                        fontSize: "16px",
                        padding: 0,
                        margin: 0
                      },
                      title: "Clear filter",
                      children: "\xD7"
                    }
                  ),
                  (state.candidates || []).length > 0 && /* @__PURE__ */ jsx(
                    "button",
                    {
                      onClick: () => this.downloadCandidatesCsv(),
                      style: {
                        padding: "4px 10px",
                        border: "1px solid #d1d5db",
                        borderRadius: "4px",
                        background: "#fff",
                        fontSize: "12px",
                        fontFamily: "inherit",
                        color: "#374151",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        margin: 0,
                        lineHeight: "normal"
                      },
                      title: "Download every loaded row",
                      children: "Download CSV"
                    }
                  )
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { style: { minHeight: "200px", position: "relative" }, children: [
            state.candidatesLoading && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Loading..." }),
            state.candidatesError && /* @__PURE__ */ jsx("div", { className: "chart-message error", children: state.candidatesError }),
            !state.candidatesLoading && !state.candidatesError && (state.candidates || []).length === 0 && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "No clients with enough reviewed invoices in this date range." }),
            !state.candidatesLoading && this.sortedCandidates().length > 0 && /* @__PURE__ */ jsxs("table", { className: "data-table", children: [
              /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsx("tr", { children: [
                ["name", "Client", "left", ""],
                [
                  "manual_review_percentage",
                  "Review %",
                  "right",
                  "Current manual review percentage. 'unset' inherits the account default of 100."
                ],
                ["reviewed", "Reviewed", "right", ""],
                [
                  "untouched",
                  "Unchanged",
                  "right",
                  "Invoices where the processor changed nothing the dry run had predicted."
                ],
                ["pct_untouched", "% Unchanged", "right", ""],
                [
                  "potential_autoprocessing",
                  "Potential Auto",
                  "right",
                  "Invoices that were unchanged AND had no rule failures, so they would have auto processed on their own."
                ],
                [
                  "pct_potential_autoprocessing",
                  "% Potential Autoprocessing",
                  "right",
                  "Share of reviewed invoices that were unchanged AND had no rule failures, so they would have auto processed on their own. A floor rather than a forecast: it requires correct data as well as passing rules, and missing PODs still count as failures."
                ]
              ].map(([key, label, align, tip]) => /* @__PURE__ */ jsxs(
                "th",
                {
                  title: tip,
                  onClick: () => this.handleCandidateSort(key),
                  style: {
                    textAlign: align,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    color: state.candidateSortKey === key ? "#3b82f6" : void 0
                  },
                  children: [
                    label,
                    state.candidateSortKey === key && (state.candidateSortAsc ? " \u25B2" : " \u25BC")
                  ]
                },
                key
              )) }) }),
              /* @__PURE__ */ jsx("tbody", { children: this.sortedCandidates().map((cand) => /* @__PURE__ */ jsxs(
                "tr",
                {
                  className: "clickable",
                  onClick: () => this.handleCandidateClick(cand),
                  style: state.selectedCandidateId === cand.carrier_id ? { background: "#eff6ff" } : {},
                  children: [
                    /* @__PURE__ */ jsx("td", { children: cand.name }),
                    /* @__PURE__ */ jsx("td", { style: { textAlign: "right" }, children: cand.manual_review_percentage === null ? "unset" : cand.manual_review_percentage }),
                    /* @__PURE__ */ jsx("td", { style: { textAlign: "right" }, children: cand.reviewed }),
                    /* @__PURE__ */ jsx("td", { style: { textAlign: "right" }, children: cand.untouched }),
                    /* @__PURE__ */ jsxs(
                      "td",
                      {
                        style: {
                          textAlign: "right",
                          fontWeight: 600
                        },
                        children: [
                          cand.pct_untouched,
                          "%"
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsx("td", { style: { textAlign: "right" }, children: cand.potential_autoprocessing }),
                    /* @__PURE__ */ jsxs("td", { style: { textAlign: "right" }, children: [
                      cand.pct_potential_autoprocessing,
                      "%"
                    ] })
                  ]
                },
                cand.carrier_id
              )) })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "card", children: [
          /* @__PURE__ */ jsxs("div", { className: "card-header", children: [
            /* @__PURE__ */ jsx("h2", { children: "Corrections" }),
            state.selectedCandidateName && /* @__PURE__ */ jsxs("span", { className: "filter-badge", children: [
              /* @__PURE__ */ jsxs("span", { children: [
                "Client: ",
                state.selectedCandidateName
              ] }),
              /* @__PURE__ */ jsx("button", { onClick: () => this.clearCandidateSelection(), children: "\xD7" })
            ] })
          ] }),
          /* @__PURE__ */ jsxs("div", { style: { minHeight: "200px", position: "relative" }, children: [
            !state.selectedCandidateId && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Select a client above to see what processors changed." }),
            state.correctionsLoading && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Loading..." }),
            state.correctionsError && /* @__PURE__ */ jsx("div", { className: "chart-message error", children: state.correctionsError }),
            !state.correctionsLoading && !state.correctionsError && state.selectedCandidateId && (state.corrections || []).length === 0 && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "No corrections for this client in this date range." }),
            !state.correctionsLoading && (state.corrections || []).length > 0 && /* @__PURE__ */ jsxs("table", { className: "data-table", children: [
              /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("th", { children: "Date" }),
                /* @__PURE__ */ jsx("th", { children: "Changes" }),
                /* @__PURE__ */ jsx("th", { children: "Invoice" })
              ] }) }),
              /* @__PURE__ */ jsx("tbody", { children: (state.corrections || []).map((corr) => /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("td", { style: { whiteSpace: "nowrap" }, children: corr.date }),
                /* @__PURE__ */ jsx("td", { children: corr.changes.map((chg, ci) => /* @__PURE__ */ jsxs("div", { children: [
                  /* @__PURE__ */ jsxs("strong", { children: [
                    chg.field,
                    ":"
                  ] }),
                  " ",
                  chg.from,
                  " ",
                  "\u2192 ",
                  chg.to
                ] }, ci)) }),
                /* @__PURE__ */ jsx("td", { children: /* @__PURE__ */ jsx(
                  "a",
                  {
                    href: "/app/factor_invoices/" + corr.invoice_id,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "Review"
                  }
                ) })
              ] }, corr.invoice_id)) })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "card", children: [
          /* @__PURE__ */ jsxs("div", { className: "card-header", children: [
            /* @__PURE__ */ jsx("h2", { children: "Rule Failures" }),
            /* @__PURE__ */ jsx("span", { style: { fontSize: "12px", color: "#6b7280" }, children: "Unchanged invoices that a rule still blocked. This is the gap between % Unchanged and % Potential Autoprocessing." })
          ] }),
          /* @__PURE__ */ jsxs("div", { style: { minHeight: "200px", position: "relative" }, children: [
            !state.selectedCandidateId && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Select a client above to see which rules blocked it." }),
            state.ruleFailuresLoading && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "Loading..." }),
            state.ruleFailuresError && /* @__PURE__ */ jsx("div", { className: "chart-message error", children: state.ruleFailuresError }),
            !state.ruleFailuresLoading && !state.ruleFailuresError && state.selectedCandidateId && (state.ruleFailures || []).length === 0 && /* @__PURE__ */ jsx("div", { className: "chart-message", children: "No rule failures on this client's uncorrected invoices in this date range." }),
            !state.ruleFailuresLoading && (state.ruleFailures || []).length > 0 && /* @__PURE__ */ jsxs("table", { className: "data-table", children: [
              /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsx("th", { children: "Rule Failure" }),
                /* @__PURE__ */ jsx("th", { style: { textAlign: "right" }, children: "Invoices" }),
                /* @__PURE__ */ jsx("th", { children: "Invoice IDs" })
              ] }) }),
              /* @__PURE__ */ jsx("tbody", { children: (state.ruleFailures || []).map((rf, i) => /* @__PURE__ */ jsxs("tr", { children: [
                /* @__PURE__ */ jsxs("td", { children: [
                  rf.label,
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        fontSize: "11px",
                        color: "#9ca3af"
                      },
                      children: rf.rule_type
                    }
                  )
                ] }),
                /* @__PURE__ */ jsx(
                  "td",
                  {
                    style: {
                      textAlign: "right",
                      fontWeight: 600
                    },
                    children: rf.invoice_count
                  }
                ),
                /* @__PURE__ */ jsx("td", { children: rf.invoice_ids.map((id, idx) => /* @__PURE__ */ jsxs("span", { children: [
                  idx > 0 && ", ",
                  /* @__PURE__ */ jsx(
                    "a",
                    {
                      href: "/app/factor_invoices/" + id,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: id
                    }
                  )
                ] }, id)) })
              ] }, i)) })
            ] })
          ] })
        ] })
      ] })
    ] }) });
  }
}
export default AnalyticsPage;
